import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import { MembersService } from 'src/app/shared/services/members.service';
import { EvaluationForm } from '../../shared-app-portal/components/lineup-applications/evaluation/models/evaluationForm';
import { EvaluationMode } from '../../shared-app-portal/components/lineup-applications/evaluation/models/evaluationMode';
import { EvaluationResponseAttributeWriteModel } from '../../shared-app-portal/components/lineup-applications/evaluation/models/evaluationResponseAttributeWriteModel';
import { MemberEvaluationDataSource } from '../../shared-app-portal/components/lineup-applications/evaluation/models/memberEvaluationDataSource';
import { MemberEvaluationStatus } from '../../shared-app-portal/components/lineup-applications/evaluation/models/memberEvaluationStatus';
import { MemberEvaluatorStatusType } from '../../shared-app-portal/components/lineup-applications/evaluation/models/memberEvaluator';
import { download } from 'src/app/shared/utils/download-file';

@Injectable({
  providedIn: 'root'
})
export class MemberEvaluationService extends BaseService {
  private _secureLinkId: string;
  public get secureLinkId(): string {
    return this._secureLinkId;
  }
  public readonly evaluation = new BehaviorSubject<EvaluationForm>(null);
  private _evaluationStarted = false;

  public readonly isLoadingOrSaving = new BehaviorSubject<boolean>(true);

  public get navigationPath(): string {
    return `/members/evaluation/${this.secureLinkId}`;
  }

  constructor(private membersService: MembersService) {
    super();
  }

  setIsLoadingOrSaving(isLoadingOrSaving: boolean) {
    this.isLoadingOrSaving.next(isLoadingOrSaving);
  }

  isEnabled(): boolean {
    return true;
  }

  starEvaluation() {
    this._evaluationStarted = true;
    this.router.navigate([`/members/evaluation/${this.secureLinkId}/${EvaluationMode.Respond}`]);
  }

  getEvaluationBySecureLinkId(secureLinkId: string) {
    this._secureLinkId = secureLinkId;
    this.get(this.getMembersBasePath(secureLinkId)).subscribe((data) => {
      if (data) {
        this.evaluation.next(EvaluationForm.parse(data));
        this.membersService.workspaceLogoUrl.next(data.form.workspaceLogoUrl);
        this.membersService.workspaceHelpLink.next(data.form.workspaceHelpLink);
      }
    });
  }
  public setEvaluationForm() {
    switch (this.evaluation.value.status) {
      case MemberEvaluationStatus.Expired:
        this.router.navigate([`${this.navigationPath}/${EvaluationMode.Expired}`]);
        break;
      case MemberEvaluationStatus.Complete:
        this.router.navigate([`${this.navigationPath}/${EvaluationMode.Confirmation}`]);
        break;
      default:
        if (!this._evaluationStarted && this.evaluation.value.hasIntroduction) {
          this.router.navigate([`${this.navigationPath}/${EvaluationMode.Introduction}`]);
        } else if (!this._evaluationStarted && !this.evaluation.value.hasIntroduction) {
          this.router.navigate([`${this.navigationPath}/${EvaluationMode.Respond}`]);
        }
        break;
    }
  }
  updateEvaluation(dataSource: MemberEvaluationDataSource[]) {
    let model: EvaluationResponseAttributeWriteModel[] = [].concat(
      ...dataSource.map((x) => x.getWriteModel())
    );
    let body = JSON.stringify(model);
    this.post(this.getMembersBasePath(this.secureLinkId), body).subscribe(() => {
      this.evaluation.value.evaluator.status = MemberEvaluatorStatusType.EvaluationCompleted;
      this.evaluation.next(this.evaluation.value);
      this.setIsLoadingOrSaving(false);
    });
  }

  downloadFile(requestUrl: string, fileName: string) {
    const encodedFileName = encodeURIComponent(fileName);
    const path = this.getMembersBasePath(requestUrl).concat(`?fileName=${encodedFileName}`);
    this.getFile(path).subscribe((res) => {
      download(res, fileName);
    });
  }

  private getMembersBasePath(secureLinkId: string): string {
    return `members/evaluations/${secureLinkId}`;
  }
}
